import React, { Component } from 'react';
import { view } from 'react-easy-state';
import Store from '../store/store';
import classNames from 'classnames';
import InputText from './InputText';
import {
  genTextValidation,
  emailValidation,
  telValidation,
  cfValidation,
  capValidation
} from '../utils/validators';
import { withTranslation } from 'react-i18next';

class DatiBlock extends Component {  
  onUpdateAnagrafica = (e) => {
    const { updateDatiPersonali } = Store;
    const key = e.target.name;
    const isCheck = e.target.type === 'checkbox';

    const val = isCheck ? 
      e.target.checked === true ? 'Y' : 'N' : 
      e.target.value;

    updateDatiPersonali(key, val);
  }

  render() {
    const { t } = this.props;

    const { 
      _anagrafica,
      anagrafica, 
      prestazioni,
      canSendRequest,
      submit,
      _isSending
    } = Store;
    
    const showDati = _anagrafica !== false && prestazioni.length > 0 ;
    
    const datiClass = classNames({
      'kfpr-box': true,
      'kfpr-box-dati': true,
      'kfpr-inactive': !showDati
    });

    const btnClass = classNames({
      'kfpr-form-row': true,
      'kfpr-row-btn': true,
      'kfpr-inactive': !canSendRequest(),
      'kfpr-sending': _isSending
    });

    return (
      <div className="kfpr-dati">        
        <div className={datiClass}>
          <div className="kfpr-box-inner">    
            <div className="kfpr-cont kfpr-cont-dati">                            
              <div className="kfpr-row kfpr-row-head">
                <span>{t("dati utente:")}</span>
                <strong>{t("Inserisci i Dati")}</strong>
              </div>
              {showDati &&
              <div className="kfpr-content kfpr-content-form">
                <div className="kfpr-form-row kfpr-form-row-datipers">
                    <div className="kfpr-form-row-title">{t("Dati Personali")}</div>
                      <div className=" kfpr-row kfpr-row-input kfpr-row-3-input">
                        <InputText label={t("Nome")} value={anagrafica.get('nome')}
                          isMandatory
                          ph={t("Nome")} 
                          onUpdate={this.onUpdateAnagrafica} 
                          validateFn={genTextValidation}
                          name="nome" />          

                        <InputText label={t("Cognome")} value={anagrafica.get('cognome')}
                          isMandatory
                          ph={t("Cognome")} 
                          onUpdate={this.onUpdateAnagrafica} 
                          validateFn={genTextValidation}
                          name="cognome" />                                           

                        <InputText label={t("Codice Fiscale")}  value={anagrafica.get('cf')}
                          isMandatory
                          ph={t("Codice Fiscale")} 
                          onUpdate={this.onUpdateAnagrafica} 
                          validateFn={cfValidation}
                          name="cf" />   
                      </div>                                         
                </div>
                <div className="kfpr-form-row kfpr-form-row-recapiti">
                    <div className="kfpr-form-row-title">{t("Recapiti")}</div>
                    <div className=" kfpr-row kfpr-row-input kfpr-row-3-input">
                      <InputText label={t("Cellulare")} value={anagrafica.get('cellulare')}
                        isMandatory
                        ph={t("Cellulare")} 
                        validateFn={telValidation}
                        onUpdate={this.onUpdateAnagrafica} 
                        name="cellulare" />

                      <InputText label={t("Email")} value={anagrafica.get('email')}
                        isMandatory
                        ph={t("Email")} 
                        validateFn={emailValidation}
                        onUpdate={this.onUpdateAnagrafica} 
                        name="email" />                                            

                      <InputText label={t("Conferma Email")} value={anagrafica.get('confemail')}
                        isMandatory
                        ph={t("Conferma Email")} 
                        validateFn={genTextValidation}
                        onUpdate={this.onUpdateAnagrafica} 
                        name="confemail" />                                            
                        
                    </div>
                </div>
                <div className="kfpr-form-row kfpr-form-row-residenza">
                    <div className="kfpr-form-row-title">{t("Residenza")}</div>
                    <div className=" kfpr-row kfpr-row-input kfpr-row-4-input">              
                      <InputText label={t("Indirizzo di residenza")} value={anagrafica.get('resIndirizzo')}
                          isMandatory
                          ph={t("Indirizzo di residenza")} 
                          onUpdate={this.onUpdateAnagrafica} 
                          extraContclassName="kfpr-input-60"
                          validateFn={genTextValidation}
                          name="resIndirizzo" />    

                      <InputText label={t("CAP")} value={anagrafica.get('resCap')}
                          isMandatory
                          ph={t("CAP")} 
                          onUpdate={this.onUpdateAnagrafica} 
                          extraContclassName="kfpr-input-40"
                          validateFn={capValidation}
                          name="resCap" />                                             

                      <InputText label={t("Comune di residenza")} value={anagrafica.get('resComune')}
                          isMandatory
                          ph={t("Comune di residenza")} 
                          onUpdate={this.onUpdateAnagrafica} 
                          validateFn={genTextValidation}
                          name="resComune" />                                         

                      <InputText label={t("Stato di residenza")} value={anagrafica.get('resStato')}
                          isMandatory
                          ph={t("Stato di residenza")} 
                          onUpdate={this.onUpdateAnagrafica} 
                          validateFn={genTextValidation}
                          name="resStato" />                                          
                    </div>
                </div>
                <div className="kfpr-form-row kfpr-form-row-trattamento-dati">
                    <div className="kfpr-form-row-title">{t("Privacy e Trattamento dei Dati")}</div>
                    
                    <div className=" kfpr-row kfpr-row-check">
                                                                    
                        <div className="kfpr-check">
                            <span className="kf-orange-txt">*</span>
                            <input type="checkbox" name="consentGdpr" onChange={this.onUpdateAnagrafica} checked={anagrafica.get('consentGdpr') === 'Y'} />
                            <label>{t("Preso atto dell'informativa di cui all'art. 13 del GDPR EU 2016/679")} </label>
                        </div>

                        <div className="kfpr-check">
                            <span className="kf-orange-txt">*</span>
                            <input type="checkbox" name="consentDati" onChange={this.onUpdateAnagrafica} checked={anagrafica.get('consentDati') === 'Y'} />
                            <label>{t("Acconsento al trattamento dei dati personali e relativi allo stato di salute al fine di effettuare la prenotazione della prestazione richiesta")}</label>
                        </div>                 
                    </div>
                </div>
                <div className="kfpr-form-row kfpr-form-row-info-comunicazioni">
                    <div className="kfpr-form-row-title">{t("Invio di Comunicazioni")}</div>
                    
                    <div className=" kfpr-row kfpr-row-check">
                                                                    
                        <div className="kfpr-check">
                            <label>{t("Invio tramite email di comunicazioni informative tipo news di servizio e aggiornamento sulle attività del Policlinico Gemelli")} </label>
                            <div className="kfpr-radio-cont">
                                <input type="radio" name="consentNews1" onChange={this.onUpdateAnagrafica} value="Y" checked={anagrafica.get('consentNews1') === 'Y'} />
                                <label>{t("Acconsento")}</label>
                                <input type="radio" name="consentNews1" onChange={this.onUpdateAnagrafica} value="N"  checked={anagrafica.get('consentNews1') === 'N'} />
                                <label>{t("Non Acconsento")}</label>                                                    
                            </div>
                        </div>

                        <div className="kfpr-check">
                            <label>{t("Invio tramite SMS di comunicazioni informative tipo news di servizio e aggiornamento sulle attività del Policlinico Gemelli.")}</label>
                            <div className="kfpr-radio-cont">
                                <input type="radio" name="consentNews2" onChange={this.onUpdateAnagrafica} value="Y"  checked={anagrafica.get('consentNews2') === 'Y'} />
                                <label>{t("Acconsento")}</label>
                                <input type="radio" name="consentNews2" onChange={this.onUpdateAnagrafica} value="N"  checked={anagrafica.get('consentNews2') === 'N'} />
                                <label>{t("Non Acconsento")}</label>                                   
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div className={btnClass}>
                    <div className="kfpr-row kfpr-row-cta">
                        { 
                          !_isSending &&
                          <div role="button" onClick={submit} className="button medium orange">{t("Invia Richiesta")}</div>
                        }
                        { 
                          _isSending &&
                          <div className="kf-loader"></div>
                        }
                    </div>
                </div>
              </div>
              }
            </div>
          </div>                       
        </div>
      </div>
    );
  }
}

export default withTranslation()(view(DatiBlock));







